function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M232.495,365.689l0,70.515l23.505,0l7.835,-70.515l-31.34,0Z",
    style: {
      fill: "#134a79",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 365.689,
    width: 23.505,
    height: 70.515,
    style: {
      fill: "#092339"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.515,
    y: 365.689,
    width: 47.01,
    height: 70.515,
    style: {
      fill: "#092339"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138.475,
    y: 365.689,
    width: 47.01,
    height: 70.515,
    style: {
      fill: "#134a79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.607,365.689l14.063,-137.112l-15.67,-152.781l-0.783,0l-179.421,303.996l0,1.567l74.432,0l11.753,-15.67l11.752,15.67l70.514,0l13.36,-15.67Z",
    style: {
      fill: "#bfbfbf",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.783,75.796l-0.783,0l0,289.893l11.753,15.67l70.514,0l11.752,-15.67l11.753,15.67l74.432,0l0,-1.567l-179.421,-303.996Z",
    style: {
      fill: "#9c9c9c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.267,
    y: 326.515,
    width: 23.505,
    height: 54.845,
    style: {
      fill: "#a4c6e2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.247,
    y: 326.515,
    width: 23.505,
    height: 54.845,
    style: {
      fill: "#d2e3f1"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 244.247,
    y: 277.421,
    width: 23.505,
    height: 23.505,
    style: {
      fill: "#134a79"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.257,
    y: 277.421,
    width: 23.505,
    height: 23.505,
    style: {
      fill: "#134a79"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 197.238,
    y: 277.421,
    width: 23.505,
    height: 23.505,
    style: {
      fill: "#1d71b8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.228,
    y: 326.515,
    width: 23.505,
    height: 54.845,
    style: {
      fill: "#d2e3f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.388,167.994l-42.544,72.081l43.156,0l7.835,-36.041l-7.835,-36.04l-0.612,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.612,167.994l-0.612,0l0,72.081l43.156,0l-42.544,-72.081Z",
    style: {
      fill: "#fac15c",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.91224f80c163d11517f1ad3293557d8b.svg";
export { ForwardRef as ReactComponent };